export default `State,2018
Baden-Württemberg,"11,069,533"
Bavaria,"13,076,721"
Berlin,"3,644,826"
Brandenburg,"2,511,917"
Bremen,"682,986"
Hamburg,"1,841,179"
Hesse,"6,265,809"
Lower Saxony,"7,982,448"
Mecklenburg-Vorpommern,"1,609,675"
North Rhine-Westphalia,"17,932,651"
Rhineland-Palatinate,"4,084,844"
Saarland,"990,509"
Saxony,"4,077,937"
Saxony-Anhalt,"2,208,321"
Schleswig-Holstein,"2,896,712"
Thuringia,"2,143,145"`
